import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import { getEmailConfiguration } from "../actionCreator/emailSetupActionCreater";
import { AuthContext } from "./AuthContext";
import { receiveEmail } from "../actionCreator/leadDetailsActionCreator";
import { getUserInfo } from "../utils/utils";

export const EmailContext = createContext();

export const EmailProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const { id } = getUserInfo();
  const location = useLocation();
  const match = location.pathname.match(/lead-details\/(\w+)/);
  const emailConfiguration = useSelector(
    (state) => state.emailSetupReducer.emailConfiguration
  );
  const loading = useSelector((state) => state.emailSetupReducer.loading);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getEmailConfiguration());
    }
    setTimeout(() => setLoading(false), 2500);
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    const fetchReceivedData = async () => {
      try {
        if (id && emailConfiguration?.email) {
          await dispatch(receiveEmail(match ? match[1] : null)); // 🔁 Your API here
        }
      } catch (err) {
        console.error("Polling failed", err);
      }
    };

    fetchReceivedData(); // Initial fetch

    const interval = setInterval(() => {
      fetchReceivedData();
    }, 30000); // 🔁 30s interval

    return () => clearInterval(interval); // 🧹 Cleanup on unmount
  }, [dispatch, id, match, emailConfiguration]);

  return (
    <EmailContext.Provider
      value={{
        isEmailConfigured: !!emailConfiguration?.email,
        emailConfiguration: emailConfiguration,
        loading: isLoading || loading,
        refetch: () => dispatch(getEmailConfiguration()),
      }}
    >
      {children}
    </EmailContext.Provider>
  );
};
